import IwtScripts from './src/scripts'

import IwtForm from './src/components/form'
import IwtTable from './src/components/table'

import IwtAccordion from './src/modules/accordion'
import IwtFlexslider from './src/modules/flexslider'
import IwtLightbox from './src/modules/lightbox2'
import IwtCarousel from './src/modules/carousel'
import IwtCookiebar from './src/modules/cookiebar'
import IwtDialog from './src/modules/dialog'
import IwtDropdown from './src/modules/dropdown'
import IwtMasonry from './src/modules/masonry'
import IwtSkiplinks from './src/modules/skiplinks'
import IwtTreeview from './src/modules/treeview'
import IwtOffcanvas from './src/modules/offcanvas'
import IwtHeadroom from './src/modules/header'
import IwtMegamenu from './src/modules/megamenu'
import IwtTooltip from './src/modules/scrolltop'
import IwtScrolltop from './src/modules/tooltip'

const __exports = {
	IwtTable,
	IwtAccordion,
	IwtFlexslider,
	IwtLightbox,
	IwtCarousel,
	IwtCookiebar,
	IwtDialog,
	IwtDropdown,
	IwtMasonry,
	IwtTreeview,
	IwtSkiplinks,
	IwtOffcanvas,
	IwtHeadroom,
	IwtMegamenu,
	IwtTooltip,
	IwtScripts,
	IwtScrolltop,
	IwtForm
}

export default __exports



// WEBPACK FOOTER //
// ./index.js